const Decimal = require('decimal.js');
// 16进制转rgba
export function hexToRgba(hex, alpha = 1) {
  let r = 0, g = 0, b = 0;

  // 3 digits
  if (hex.length == 4) {
    r = "0x" + hex[1] + hex[1];
    g = "0x" + hex[2] + hex[2];
    b = "0x" + hex[3] + hex[3];
  // 6 digits
  } else if (hex.length == 7) {
    r = "0x" + hex[1] + hex[2];
    g = "0x" + hex[3] + hex[4];
    b = "0x" + hex[5] + hex[6];
  }

  return "rgba(" + +r + "," + +g + "," + +b + "," + alpha + ")";
}
/**
 * 复制文本
 * @param {*} t
 */
export function copyText(text) {
  // 创建一个临时的textarea元素
  var textarea = document.createElement("textarea");
  // 设置textarea的值为要复制的文本
  textarea.value = text;
  // 将textarea元素添加到文档中
  document.body.appendChild(textarea);
  // 选择textarea中的文本
  textarea.select();
  // 执行复制命令
  document.execCommand("copy");
  // 移除临时的textarea元素
  document.body.removeChild(textarea);
}

export function amountFormat(amount) {
  amount = amount || 0
  amount = parseFloat(amount)
  if (amount == 0) {
    return amount
  }

  return new Decimal(amount).toFixed(2)
}
export function formatAmount(amount) {
  if (amount) {
    let num = amount.toString().split('').map((item, index, self) => {
      if (isNaN(Number(item))) {
        if (item == '.' && self.indexOf(item) == index) {
          return item
        }
        return ''
      }
      return item
    }).join('')
    let dotIndex = num.indexOf('.')
    if (dotIndex != -1) {
      if (num.slice(dotIndex).length > 2) {
        num = num.slice(0, dotIndex+3)
      }
      if (dotIndex != 0 && num.slice(0, dotIndex) < 1) {
        num = 0 + num.slice(dotIndex)
      }
    }
    return num
  }
  else {
    return ''
  }
}

// export function formatAmount(amount) {
//   if (amount) {
//     let num = amount.toString().split('').map((item, index, self) => {
//       if (isNaN(Number(item))) {
//         if (item == '.' && self.indexOf(item) == index) {
//           return item
//         }
//         return ''
//       }
//       return item
//     }).join('')
//     let dotIndex = num.indexOf('.')
//     if (dotIndex != -1) {
//       if (num.slice(dotIndex).length > 2) {
//         num = num.slice(0, dotIndex+3)
//       }
//       if (dotIndex != 0 && num.slice(0, dotIndex) < 1) {
//         num = 0 + num.slice(dotIndex)
//       }
//     }
//     return num
//   }
//   else {
//     return ''
//   }
// }

// 金额转换为大写
export function convertCurrency(money) {
  //汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  var cnInteger = '整';
  //整型完以后的单位
  var cnIntLast = '元';
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  //金额整数部分
  var integerNum;
  //金额小数部分
  var decimalNum;
  //输出的中文金额字符串
  var chineseStr = '';
  //分离金额后用的数组，预定义
  var parts;
  if (money == '') { return ''; }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
}
// 金额转换为小写
export function formatDollars(s) {
  var s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(2) + "";
  var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];
  var t = "";
  for (var i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
  }
  return t.split("").reverse().join("") + "." + r;
}


// 图片url转base64
export function imageUrlToBase64(url) {
  return fetch(url)
    .then(response => response.blob())
    .then(blob => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    });
}

// 倒计时
export function countdown(options = {
  expireTime: '',
  format: 'D天H时m分s秒',
  callback: null
}) {
  // 将时间字符串转换为 Date 对象
  const end = new Date(options.expireTime);

  // 计算倒计时时间间隔（毫秒）
  const timeInterval = setInterval(() => {
      // 获取当前时间
      const now = new Date();

      // 如果当前时间超过结束时间，停止倒计时
      if (now >= end) {
          clearInterval(timeInterval);
          console.log("倒计时结束");
          return callback && callback({result: 0, years: 0, months: 0, days: 0, hours: 0, minutes: 0, seconds: 0});
      }

      // 计算剩余时间
      const remainingTime = end - now;

      // 转换为年、月、天、小时、分钟和秒
      const years = Math.floor(remainingTime / (1000 * 60 * 60 * 24 * 365));
      const months = Math.floor((remainingTime % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30));
      const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

      // 格式化输出
      let format = options.format || "Y-M-D H:m:s";
      let result = format.replace(/Y/g, years)
         .replace(/M/g, months)
         .replace(/D/g, days)
         .replace(/H/g, hours)
         .replace(/m/g, minutes)
         .replace(/s/g, seconds);

      // 输出结果
      console.log(result);

      // 回调函数
      options.callback && options.callback({result, years, months, days, hours, minutes, seconds, end: !(years + months + days + hours + minutes + seconds)});
  }, 1000); // 每秒更新一次
  return timeInterval;
}
